
<template>
  <v-container>
    <h2>Kiosks involved by the job</h2>
    <v-autocomplete
      chips
      filled
      multiple
      rounded
      clearable
      deletable-chips
      solo
      v-model="values"
      :items="items"
      class="ma-4"
    ></v-autocomplete>

    <h2>Job's type</h2>
    <v-autocomplete
      chips
      clearable
      filled
      rounded
      solo
      class="ma-4"
      :items="jobTypeItems"
      v-model="values2"
    ></v-autocomplete>

    <v-row>
      <div v-if="values2 == 'noSleep'">
        <NoSleepConfig @sendNoSleep="handleNoSleep($event)"></NoSleepConfig>
      </div>
      <div v-if="values2 == 'getReport'">
        <get-report-config
          @sendGetReport="handleGetReport($event)"
        ></get-report-config>
      </div>
      <div v-if="values2 == 'appUpdate'">
        <AppUpdateConfig
          @sendAppUpdate="handleAppUpdate($event)"
        ></AppUpdateConfig>
      </div>
      <div v-if="values2 == 'getDiag'">
        <get-diag-config @sendGetDiag="handleGetDiag($event)"></get-diag-config>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import NoSleepConfig from "@/components/configComponents/NoSleepConfig";
import GetReportConfig from "@/components/configComponents/GetReportConfig";
import AppUpdateConfig from "@/components/configComponents/AppUpdateConfig";
import GetDiagConfig from "./configComponents/GetDiagConfig.vue";


const jobTypes = {
  noSleep: "NoSleepJob",
  getReport: "GetReportJob",
  appUpdate: "AppUpdateJob",
  weRepair: "WeRepairJob",
  getDiag: "GetDiagJob",
  setOrGetConf: "SetOrGetConfJob",
  setOrGetUser: "SetOrGetUserJob",
  setUser: "SetUserJob",
  getUser: "GetUserJob",
  setConf: "SetConfJob",
  getConf: "GetConfJob",
};
export default {
  name: "CreateJobs",
  components: {
    NoSleepConfig,
    GetReportConfig,
    AppUpdateConfig,
    GetDiagConfig,
  },

  data: () => ({
    values: [],

    items: [],
    kiosks: [],

    jobTypeItems: Object.keys(jobTypes),
    values2: [],

    baseURL: process.env.VUE_APP_API_EXT_URL,

    sendSuccess: 0,
    sendError : 0,
  }),

  mounted() {
    this.refreshDatas(true);
    
  },

  methods: {

    sendDatasAtPathForKiosks:  function(data, path, kiosks){

      this.sendSuccess =0;

      this.sendError = 0;

     
          kiosks.forEach( async (kiosk, index, array) =>{
                await this.sendDatasAtPath(data, path+kiosk);


                if(index=== array.length-1){
                    await window.alert(`error : ${this.sendError}   success : ${this.sendSuccess}`);
                }
                

          });

       



      
        

    },
    sendDatasAtPath: function (data, path) {


      ////console.log("We send {", data, '} at path ',path);

      return new Promise((resolve, reject)=>{
          axios
        .post(this.baseURL + path, data, {
          headers:{Authorization: 'Bearer '+localStorage.getItem('jwt')}
        })
        .then((doc) => {
          this.sendSuccess += 1;
          resolve(doc);

        })
        .catch((error) => {
          this.sendError+=1;
          reject(error)

        });
      });

      
    },
    refreshDatas: function (isPopulated) {
      let that = this;

      var config = {
        method: "get",
        url: this.baseURL + "/kiosks?isPopulated=" + isPopulated,
        headers: {
          Authorization: 'Bearer '+localStorage.getItem('jwt')
        },
      };

      axios(config)
        .then(function (response) {
          that._data.kiosks = response.data;
          that.fullItemsWithName();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    fullItemsWithName: function () {
      this.kiosks.forEach((element) => {
        this.items.push(element.name);
      });
    },

    handleNoSleep: function (e) {
      //console.log("handleNoSleep");
      //console.log(e);
      this.sendDatasAtPathForKiosks(
        { date: e },
        "/job/" + jobTypes.noSleep + "/" , this.values
      );
      
    },
    handleGetReport: function (e) {
      //console.log("handleGetReport");
      //console.log(e);
      this.sendDatasAtPathForKiosks(
        { reportToGet: e },
        "/job/" + jobTypes.getReport + "/",this.values
      );
      
    },
    handleAppUpdate: function (e) {

      let isCritic=true;
      if(e===null){
        isCritic = false
      }
      //console.log("Is it checked ??  : ");
      //console.log(e);
      this.sendDatasAtPathForKiosks(
        { isCritic: isCritic },
        "/job/" + jobTypes.appUpdate + "/" ,this.values
      );
    },
    handleGetDiag: function (e) {
      //console.log("DIAG TO MAKE ");
      //console.log(e);
      this.sendDatasAtPathForKiosks(
        { periphsToDiag: e },
        "/job/" + jobTypes.getDiag + "/" , this.values
      );
    },
  },
};
</script>
